import type { ReactNode } from 'react';
import { SnackbarProvider } from '@/components/feedback/SnackbarProvider';

type FeatureProvidersProps = {
  readonly children: ReactNode;
};

export function FeatureProviders({ children }: FeatureProvidersProps) {
  return <SnackbarProvider>{children}</SnackbarProvider>;
}
